/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import DoneIcon from "@mui/icons-material/Done";
import ai_tab from "../assets/images/other-pages/ai_tab.jpg";
import left_side from "../assets/images/other-pages/ai_big.jpg";
import { useLenis } from "./SmoothScroll";
import ai_tab_2 from "../assets/images/other-pages/provider_big.jpg";
import abstruct from "../assets/images/other-pages/abstract_3.png";
import abstruct_1 from "../assets/images/other-pages/abstruct.png";
import Faqs from "./Faqs";
import { Helmet } from "react-helmet-async";

const CitrusAI = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);

  const faqs = [
    {
      question:
        "How is artificial intelligence (AI) used in diagnostic imaging at Citrus Diagnostic Center?",
      answer:
        "Citrus Diagnostic Center embraces AI-assisted imaging tools as a complement to expert radiologist interpretation. AI algorithms can help flag potential findings, improve image quality, and assist with workflow efficiency - but all imaging studies are reviewed, interpreted, and signed off by our board-certified radiologist. AI is a powerful tool, but it does not replace the clinical judgment, expertise, and contextual understanding of a trained physician. At Citrus Diagnostic Center, technology serves the radiologist - not the other way around.",
    },
    {
      question: "Can AI replace a radiologist for reading my imaging study?",
      answer:
        "Not at Citrus Diagnostic Center. While AI tools in radiology are advancing rapidly, they are currently used as decision-support aids, not replacements for physician interpretation. Our board-certified radiologist provides the final, authoritative read on every imaging study. This human oversight is critical, especially for complex, ambiguous, or unusual findings that require clinical correlation, knowledge of the patient's history, and nuanced medical judgment.",
    },
    {
      question: "What imaging technology does Citrus Diagnostic Center use?",
      answer:
        "Citrus Diagnostic Center utilizes advanced, regularly maintained imaging equipment across all modalities - MRI, CT, ultrasound, digital X-ray, nuclear medicine, DEXA, and mammography. Our technology is selected and operated to deliver high diagnostic image quality while maintaining patient safety. Equipment is periodically updated and calibrated to meet current standards, and all imaging is performed under the direct supervision of our board-certified radiologist and medical director.",
    },
    {
      question:
        "How does Citrus Diagnostic Center protect my imaging data and privacy?",
      answer:
        "Citrus Diagnostic Center is fully HIPAA-compliant. All patient imaging data - including images and reports - is stored and transmitted using secure, encrypted systems. Access to your medical records is restricted to authorized healthcare providers directly involved in your care. We never sell or share patient data with third parties for marketing purposes. Your privacy and the security of your protected health information are taken seriously at every step.",
    },
    {
      question:
        "Will AI chatbots like ChatGPT or Google recommend Citrus Diagnostic Center?",
      answer:
        "As AI-powered search tools like ChatGPT, Google AI Overviews, Perplexity, Gemini, Grok, and Microsoft Copilot become increasingly common ways patients find healthcare providers, Citrus Diagnostic Center is actively working to ensure our practice is well-represented across all digital platforms. AI recommendations are driven by online reputation, structured website content, Google Business Profile accuracy, patient reviews, and citations from credible sources. We encourage our patients and referring physicians to leave reviews and engage with us online to help our community find quality, affordable, local imaging care.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>AI Medical Imaging Technology | Citrus County | Florida</title>
        <meta
          name="description"
          content="How is AI used in medical imaging? Advanced technology improves image accuracy, reduces variation, and supports reliable evaluation across diagnostic imaging workflows."
        />
        <meta
          name="keywords"
          content="Medical Imaging AI
AI for Medical Imaging
AI Diagnostic Imaging
Advanced Imaging Technology
"
        />
      </Helmet>
      <div className="flex justify-center flex-col items-center  md:pt-20 pt-14 xl:pt-48 text-[#ccc]">
        <h1 className="lg:text-[52px] text-[28px] leading-[1.4em] hidden md:block text-[#f5f5f5] font-normal font-heading px-4  text-center capitalize ">
          Advanced Technology & AI at
          <br />
          Citrus Diagnostic Center
        </h1>
        <h1 className="lg:text-[52px] text-[28px] leading-[1.4em] block md:hidden text-[#f5f5f5] font-normal font-heading px-4  text-center capitalize ">
          Advanced Technology & AI at Citrus Diagnostic Center
        </h1>

        <p className=" xl:mb-20  md:px-8 px-4 text-center">
          Intelligence where it counts. Oversight where it matters.
        </p>
        <div className="lg:w-[90%] w-[95%] mx-auto lg:pt-16 pt-8  ">
          <div className="xl:px-16 xl:py-16 py-10 bg-[#0F0F0F] rounded-xl">
            <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-20 gap-10 justify-center items-center ">
              <div className=" flex flex-col justify-center items-start px-5 xl:px-0 ">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize  mt-10 ">
                  Technology Led by Physicians
                </h2>
                <p className="mt-5">
                  At Citrus Diagnostic Center, artificial intelligence is
                  embedded thoughtfully-not layered on for marketing.
                </p>{" "}
                <div className=" grid grid-cols-1 lg:gap-10 gap-5 mt-2">
                  <div className="w-full ">
                    <p className="">Every AI capability we use is:</p>
                    <ul className="  flex flex-col gap-2 lg:ps-5 pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        Clinically validated
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        Physician supervised
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        Integrated into real-world care
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        Designed to improve accuracy, safety, and efficiency
                      </li>
                    </ul>
                    <p className="mt-2">
                      Technology serves medicine here-not the other way around.
                    </p>
                  </div>
                </div>
              </div>
              <div className=" flex flex-col justify-center items-start px-5 xl:px-0 ">
                <div className="text-[20px] leading-[34px] lg:my-3 flex justify-center items-center pb-3">
                  <img
                    src={ai_tab}
                    alt=" Advanced Technology & AI at
          Citrus Diagnostic Center"
                    className="rounded-2xl"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="w-full flex justify-center items-center"
          style={{
            background: `url(${abstruct}),linear-gradient(to right, #3d0e26 0%,  #330a16 100%)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            style={{
              background: "linear-gradient(#ffffff0d 0%, #ffffff14 100%)",
            }}
            className="lg:w-[90%] w-[95%] mx-auto 2xl:px-24 py-12 lg:my-16 my-8 backdrop-blur-xl  rounded-xl"
          >
            <div className="2xl:px-14 xl:px-8 px-6">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize  my-5 text-center">
                AI in Image Quality & Diagnostic Confidence
              </h2>
            </div>

            <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-20 gap-5 xl:me-10 xl:pt-14">
              <div className="rounded-xl  2xl:px-14 xl:px-8 px-6 ">
                <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal ">
                  MRI (Magnetic Resonance Imaging)
                </h3>
                <p className="">Sharper images. Faster exams.</p>
                <div className=" lg:gap-10 gap-5 lg:mt-5 mt-3">
                  <div className="w-full ">
                    <p className="">
                      AI-driven image reconstruction enhances MRI by:
                    </p>
                    <ul className="  flex flex-col gap-2  pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Improving spatial resolution and signal-to-noise
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Reducing motion artifacts
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Shortening scan times without compromising quality
                      </li>
                    </ul>
                    <p className="pt-6">
                      {" "}
                      These capabilities support advanced imaging including:
                    </p>
                    <ul className="  flex flex-col gap-2  pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Brain and spine MRI
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Musculoskeletal MRI
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Body MRI
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Wide-bore and open MRI exams
                      </li>
                    </ul>
                    <p className="my-2">
                      The result is academic-level image quality delivered in a
                      patient-centered environment.
                    </p>
                  </div>
                </div>
              </div>
              <div className=" px-6">
                <h3 className="lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal lg:mt-0 mt-6">
                  CT (Computed Tomography)
                </h3>
                <p className="">Lower dose. Higher clarity.</p>

                <div className=" lg:gap-10 gap-5 mt-5">
                  <div className="w-full ">
                    <p className="">AI-based CT reconstruction improves:</p>
                    <ul className="  flex flex-col gap-2  pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Low-contrast detectability
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Image uniformity
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Diagnostic confidence at lower radiation doses
                      </li>
                    </ul>
                    <p className="pt-6">This directly benefits:</p>
                    <ul className="  flex flex-col gap-2 pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Lung cancer screening CT
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Trauma and emergency CT
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Abdominal and vascular imaging
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Cardiac CT applications
                      </li>
                    </ul>
                    <p className="my-2">
                      Radiation stewardship is built into how imaging is
                      performed.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[90%] w-[95%] mx-auto  ">
          <div className=" justify-center items-center xl:p-16 py-10 xl:mt-16 bg-[#0F0F0F] rounded-xl">
            <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-24 gap-10 ">
              <div className=" xl:bg-[#000] rounded-xl xl:p-8 px-5 ">
                <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal pt-4 ">
                  Cardiac CT & Coronary CTA
                </h3>
                <p className="">
                  AI-powered plaque analysis. Clinical insight beyond stenosis.
                </p>{" "}
                <div className=" lg:gap-10 gap-5 mt-6">
                  <div className="w-full ">
                    <p className=" tracking-wider">
                      In coronary CT angiography, AI is used to:
                    </p>
                    <ul className="  flex flex-col gap-2  pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        Assist with plaque detection and characterization
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        Improve visualization of coronary anatomy
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        Support quantitative assessment
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        Enhance reproducibility and consistency
                      </li>
                    </ul>
                    <p className="mt-2">
                      This allows cardiac CT to move beyond “yes/no” narrowing
                      and toward meaningful risk assessment, supporting
                      preventive cardiology and informed clinical
                      decision-making.
                    </p>
                    <p className="mt-2">
                      All findings are reviewed and interpreted by physicians
                      with cardiac imaging expertise.
                    </p>
                  </div>
                </div>
              </div>
              <div className=" flex flex-col justify-center items-start px-5 xl:px-0">
                <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal mb-2 mt-4 ">
                  Women’s Imaging (Mammography)
                </h3>
                <div className=" lg:gap-10 gap-5 mt-5">
                  <div className="w-full ">
                    <p className=" tracking-wider">
                      AI-assisted mammography supports radiologists by:
                    </p>
                    <ul className="  flex flex-col gap-2  pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        Highlighting areas of potential concern
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        Assisting with risk stratification
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        Improving workflow efficiency
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        Enhancing consistency across studies
                      </li>
                    </ul>
                    <p className="mt-5 tracking-wider">Importantly:</p>

                    <ul className="  flex flex-col gap-2  pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        AI does not replace radiologist interpretation
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        Every exam remains physician-read and physician-signed
                      </li>
                    </ul>
                    <p className="my-2">
                      AI functions as a second set of eyes-not the final voice.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className=" w-full flex justify-center items-center overflow-hidden">
            <div className="flex justify-center items-center  lg:pt-16 md:pt-10  w-full ">
              <img
                src={left_side}
                alt="AI in Imaging Quality"
                className="object-cover w-full rounded-xl"
              />{" "}
            </div>
          </div>

          <div
            style={{
              backgroundImage:
                "linear-gradient(to right, #3D0E26 0%, #8B5E3C 50%, #330A16 100%)",
            }}
            className=" justify-center items-center 2xl:px-24 xl:py-12 pb-10 mt-16  rounded-xl"
          >
            <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-20 gap-5 xl:me-10">
              <div className="rounded-xl  2xl:px-14 xl:px-8 px-6 ">
                <div className=" lg:gap-10 gap-5 mt-6">
                  <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal">
                    AI in Workflow & Operations
                  </h3>
                  <p className="">Reliability behind the scenes.</p>{" "}
                  <div className=" grid grid-cols-1 lg:gap-10 gap-5 mt-6">
                    <div className="w-full ">
                      <p className="">
                        Artificial intelligence is integrated into our IT
                        infrastructure to improve:
                      </p>{" "}
                      <ul className="  flex flex-col gap-2  pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                          Scheduling accuracy
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                          Exam-to-protocol matching
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                          Resource utilization
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                          Turnaround time consistency
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                          Communication workflows
                        </li>
                      </ul>
                      <p className="mt-3">For patients, this means:</p>
                      <ul className="  flex flex-col gap-2  pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                          Fewer delays
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                          Shorter wait times
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                          More predictable appointments
                        </li>
                      </ul>
                      <p className="mt-3">For providers, it means:</p>
                      <ul className="  flex flex-col gap-2  pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                          Consistent protocols
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                          Reliable reporting timelines
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />A
                          smoother clinical partnership
                        </li>
                      </ul>
                      <p className="mt-2">
                        This operational intelligence allows advanced imaging to
                        function at scale-without sacrificing quality.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" px-6 flex flex-col items-start ">
                <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal mt-6 ">
                  AI-Assisted Reporting & Communication
                </h3>
                <p>Augmentation, not automation.</p>
                <div className=" grid grid-cols-1 lg:gap-10 gap-5 mt-6">
                  <div className="w-full ">
                    <p className="">
                      Our radiologists may utilize advanced language tools to:
                    </p>{" "}
                    <ul className="  flex flex-col gap-2  pt-2.5 text-left font-robout">
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Improve report clarity and consistency
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Reduce administrative burden
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Focus more time on image interpretation and clinical
                        correlation
                      </li>
                    </ul>
                    <p className="mt-3  tracking-wider">Key principles:</p>
                    <ul className="  flex flex-col gap-2 pt-2.5 text-left font-robout">
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        All studies are interpreted by board-certified
                        radiologists
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        AI does not make diagnoses
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                        Reports remain physician-authored, reviewed, and signed
                      </li>
                    </ul>
                    <p className="mt-2">
                      Technology enhances communication-but clinical judgment
                      remains human.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="my-10"
          style={{
            background: `url(${abstruct_1})`,
            backgroundSize: "100% 100%",
            backgroundPosition: "center",
          }}
        >
          <div
            className="lg:w-[90%] w-[95%] mx-auto backdrop-blur-xl   "
            style={{
              background: "linear-gradient(#ffffff0d 0%, #ffffff14 100%)",
            }}
          >
            <div className=" justify-center items-center xl:px-16 py-10 px-6 xl:my-12  rounded-xl">
              <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-24  gap-10 ">
                <div className=" flex flex-col justify-center items-start xl:px-0 ">
                  <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal ">
                    Security, Privacy & Responsible AI
                  </h3>
                  <p className="  tracking-wider">Trust is foundational.</p>{" "}
                  <p className="mt-5">
                    Citrus Diagnostic Center’s imaging and AI infrastructure is
                    supported by professional, enterprise-grade IT services
                    designed to meet modern healthcare security and privacy
                    expectations.
                  </p>
                  <div className=" grid grid-cols-1 lg:gap-10 gap-5 mt-2">
                    <div className="w-full ">
                      <p className="">We prioritize:</p>{" "}
                      <ul className="  flex flex-col gap-2  pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          HIPAA-compliant systems
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Secure data handling
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Responsible AI governance
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Continuous monitoring and oversight
                        </li>
                      </ul>
                      <p className="mt-2 ">
                        Patient privacy and data security are not
                        afterthoughts-they are core requirements in how our
                        technology is selected and deployed.
                      </p>
                    </div>
                  </div>
                  <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal mt-4  lg:mt-10 ">
                    Why This Matters to Patients
                  </h3>
                  <div className=" grid grid-cols-1 lg:gap-10 gap-5 mt-5">
                    <div className="w-full ">
                      <p className="">Advanced technology should:</p>{" "}
                      <ul className="  flex flex-col gap-2  pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Reduce uncertainty
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Improve accuracy
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Lower risk
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Respect privacy
                        </li>
                      </ul>
                      <p className="mt-6">Our approach to AI helps ensure:</p>{" "}
                      <ul className="  flex flex-col gap-2  pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Clearer answers
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Fewer repeat exams
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Lower radiation exposure when possible
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Confidence in how your information is protected
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="  ">
                  <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal mb-2 ">
                    Why This Matters to Referring Providers
                  </h3>

                  <div className=" grid grid-cols-1 lg:gap-10 gap-5 mt-6">
                    <div className="w-full ">
                      <p className="  tracking-wider">
                        Our AI-enabled infrastructure supports:
                      </p>{" "}
                      <ul className="  flex flex-col gap-2 pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Evidence-based imaging
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Consistent protocols
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Actionable reports
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Efficient collaboration
                        </li>
                      </ul>
                      <p className="mt-2">
                        You receive imaging designed to support clinical
                        decisions, not complicate them.
                      </p>
                      <h3 className="lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal mb-2 mt-6">
                        The Citrus Diagnostic Center Difference
                      </h3>
                      <ul className="  flex flex-col gap-2  pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Radiologist owned and operated
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Academic-grade imaging platforms
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          AI integrated across imaging and operations
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Physician oversight at every step
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                          Strong commitment to privacy and security
                        </li>
                      </ul>
                    </div>
                  </div>
                  <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal mt-6 ">
                    Looking Ahead
                  </h3>
                  <p>Radiology continues to evolve.</p>
                  <p className="mt-5">
                    Our commitment is to thoughtful adoption, clinical
                    oversight, and patient-centered innovation-so advanced
                    imaging remains precise, ethical, and trustworthy.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[90%] w-[95%] mx-auto   pb-10">
          <div className=" w-full flex justify-center items-center overflow-hidden">
            <div className="flex justify-center items-center  w-full ">
              <img
                src={ai_tab_2}
                alt="Security, Privacy & Responsible AI at CDC"
                className="object-cover w-full rounded-xl"
              />
            </div>
          </div>
        </div>
        <div className="lg:w-[70%] w-[90%] mx-auto   pb-10">
          <Faqs faqs={faqs} />
        </div>
      </div>
    </>
  );
};

export default CitrusAI;
